<template>
  <button
    type="button"
    :style="{ '--hovercolor': item.color }"
    @click="handleNavItemClick(item, $event)"
  >
    {{ item.title }}
  </button>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "SustainbilityJumpToNavItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions("sustainability", ["updateSelectedSection", "toggleMenu"]),
    handleNavItemClick(item, event) {
      console.log(event.target.closest(".navigation"));
      if (event.target.closest(".navigation")) {
        this.toggleMenu();
      }
      this.updateSelectedSection({ section: item.slug, navigate: true });
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  outline: none;
  background-color: transparent;
  margin: 10px 0;
  display: inline-block;
  text-decoration: none;
  padding: 0 30px;
  line-height: 1;
  font-size: 28px;
  text-transform: uppercase;
  font-family: $heading-font-family !important;
  border: none;

  @include respond-above(md) {
    margin: 15px 0;
    padding: 0 50px;
    font-size: 60px;
  }
}

button:hover {
  background-color: var(--hovercolor);
}
</style>
